var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"outline",class:{
    'outline--error': _vm.hasError,
    'outline--focused': _vm.focused,
    'outline--hovering': _vm.hovering,
  }},[_c('div',{staticClass:"outline__left"}),_c('div',{staticClass:"outline__center",class:{ 'outline__center--notch': _vm.shouldMinimizeLabel }},[(_vm.label)?_c('label',{staticClass:"label",class:{
        'label--disabled': _vm.disabled,
        'label--error': _vm.hasError,
        'label--focused': _vm.focused,
        'label--minified': _vm.shouldMinimizeLabel,
        'subtitle-1': !_vm.large,
        h6: _vm.large,
      },style:(_vm.labelInlineStyle)},[_vm._v(" "+_vm._s(_vm.label)),(_vm.required)?_c('span',{staticClass:"label__required"},[_vm._v("*")]):_vm._e()]):_vm._e()]),_c('div',{staticClass:"outline__right"})])}
var staticRenderFns = []

export { render, staticRenderFns }